import type { SvgProps } from "../types";

export const FoodSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Food</title>
      <path
        opacity="0.503384"
        d="M65.9551 188.091C80.2811 168.045 84.4413 158.902 103.464 168.195C106.921 169.883 107.164 161.441 109.899 158.77C119.559 149.331 125.56 140.514 140.974 142.017C150.314 142.93 156.861 159.819 158.124 159.819C169.653 159.819 178.867 145.672 194.56 152.487C201.278 155.406 214.707 165.673 218.14 172.383C218.628 173.335 217.748 181.808 218.14 181.808C232.475 181.808 239.573 172.387 248.146 189.135"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M256.011 204.434C221.823 210.383 209.796 211.397 163.565 211.397C103.089 211.397 59 201.487 59 211.397C59 253.526 79.472 275.267 120.416 276.622L117.114 306.393C129.494 309.813 146.543 311.523 168.26 311.523C189.976 311.523 203.981 309.813 210.274 306.393L206.715 276.622C242.679 275.145 260.662 256.6 260.662 220.986"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M316.293 89C308.538 92.1498 297.101 94.9953 288.84 98.1041C268.12 105.9 245.232 113.697 225.928 121.541C220.928 123.573 199.989 131.594 204.195 130.645"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M341.326 127.941C333.763 129.411 322.608 130.739 314.551 132.19C294.342 135.828 272.019 139.466 253.192 143.127C248.316 144.075 227.893 147.819 231.996 147.376"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
